import { render, staticRenderFns } from "./created.vue?vue&type=template&id=5baa5cf6&scoped=true&"
import script from "./created.vue?vue&type=script&lang=js&"
export * from "./created.vue?vue&type=script&lang=js&"
import style0 from "./created.vue?vue&type=style&index=0&id=5baa5cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa5cf6",
  null
  
)

export default component.exports